
import React, { useContext, useEffect, useRef, useState } from 'react'
import { SelectOption } from '../../../shared/components/input/SelectOption'
import TextInputWithLabelInline from '../../../shared/components/input/TextInputWithLabelInline'
import { ErrorBoundary } from 'react-error-boundary'
import _, { update } from 'lodash'
import Logger from '../../../shared/services/Logger'
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import * as constant from '../../../shared/util/constant'
import { Button, Container, FloatingLabel, Form, Nav, Tab } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import * as label from '../../../shared/util/label'
import { Card, Collapse } from 'react-bootstrap'
import { Row } from "react-bootstrap";
import { Column, Checkbox, Select } from "../../../components";
import DropDownWithLabelInline from "../../../shared/components/input/DropDownWithLabelInline";
import { CustomerScreentLables as cstScrLables } from "../../../shared/util/label";
import { userSetupUtils } from '../../utils/UserSetupUtils'
import EmployeeSetupService from '../service/EmployeeSetupService'
import './../UserSetupMiniTabs.scss';
import { AbilityContext } from '../../../shared/abilities/AbilityContext';
import { FloatLabel } from 'primereact/floatlabel'
import { InputMask } from 'primereact/inputmask';

import * as tableId from '../../../shared/util/tableConstant'

import { useTable } from 'react-table';
import { table } from 'console'
import EmployeeSetupModel from '../../model/EmployeeSetupModel'

import e from 'express'

export interface IEmployeeView {
  relationships: SelectOption[],
  onFieldChange: (collectionPropName: string, collectionEntityIdentifierPropName: string, collectionEntityIdentifierValue: any, propName: string, value: string | Date | boolean) => void,
  // onDelete : (dependent : CustomerDependent) => void,
  formValidations: any,
  isEditable: boolean,
  isReset: boolean
  setOpen: (key: string) => void;
  loadDataFlag: (key: boolean) => void;
  firstNameRef: any
}

const EmployeeDetails: React.FunctionComponent<IEmployeeView> = ({ firstNameRef, employeeDetail, setEmployeeDetail, setOpen, loadDataFlag }) => {
  const ability = React.useContext(AbilityContext);
  const canUpdate = ability.can('update', constant.AdminSubject, constant.AdminScreenPrivileges.User_Setup);
  const canDelete = ability.can('delete', constant.AdminSubject, constant.AdminScreenPrivileges.User_Setup);

  const employeeSetup: EmployeeSetupModel = {
    id: constant.DEFAULT_GUID,
    agencyGroupId: '',
    firstName: '',
    lastName: '',
    middleName: '',
    title: '',
    email: '',
    employeeStatusId: '',
    agencyId: '',
    legacyEmpCode: '',
    workPhone: '',
    workPhoneExt: '',
    countryCode: '',
    fullPartTimeIndId: '',
    empSupervisorCode: '',
    changedDate: '',
    enteredDate:'',
    changedByName: '',
    isActive: false,
    departmentId: ''
    // roleId: ''
  }

  const employeeSetupService = new EmployeeSetupService()

  const [activeTab, setActiveTab] = useState('tab1');
  const history = useHistory();

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };



  const [employeeStatusOptions, setEmployeeStatus] = useState<SelectOption[]>([]);
  const [agencyGroups, setAgencyGroups] = useState<SelectOption[]>([]);
  const [selectedAgencyGroup, setSelectedAgencyGroup] = useState([]);
  const [agencies, setAgencyList] = useState<SelectOption[]>([]);
  // const [employeeDetail, setEmployeeDetail] = useState(employeeSetup);
  const [isEditable, setIsEditable] = useState(true);
  const [employeeList, setEmployeeList] = useState<SelectOption[]>([]);
  const [indicatorList, setIndicators] = useState<SelectOption[]>([]);
  const [roleList, setRoleList] = useState<SelectOption[]>([]);
  const [employeeDepartmentOptions, setEmployeeDepartmentOptions] = useState<SelectOption[]>([]);
  const [formValidation, setFormValidation] = useState<any>({});
  const [savedData, setDataSaved] = useState(false);
  // const firstNameRef = useRef(null);

  useEffect(() => {

    if (employeeDetail) {
      handleAgencyGroupChange(employeeDetail.agencyGroupId);
      // Perform side effects with employeeDetail
    }
  }, [employeeDetail]);
  useEffect(() => {
    //alert('called')
    // userSetupUtils.getDropdownOptions(tableId.EMPLOYEE_STATUS)?.then(res => {
    //   let filteredRes = res.filter(item => item.label.toLowerCase() !== "deleted");
    //   setEmployeeStatus(filteredRes)
    // })
    userSetupUtils.getDropdownOptions(tableId.EMPLOYEE_FULLTIMEIND)?.then(res => {
      setIndicators(res)
    })
    userSetupUtils.getDropdownOptions(tableId.EMPLOYEE_DEPARTMENT)?.then(res => {
      setEmployeeDepartmentOptions(res)
    })
    // userSetupUtils.getAppRoles(tableId.ROLE_APP_ID)?.then(res => {
    //     setRoleList(res)
    // })
    userSetupUtils.getAgencyGroups()?.then(res => {
      setAgencyGroups(res)
    })
    userSetupUtils.getEmployeeList()?.then(res => {
      setEmployeeList(res);
    })
    userSetupUtils.getEmployeeList()?.then(res => {
      setEmployeeList(res);
    })

  }, []);

  const manageActiveToggle = (event) => {
    if (event.target.checked) {
      onEntityFieldChange("isActive", event.target.checked)
    }
    else {
      onEntityFieldChange("isActive", event.target.checked)
    }
  }
  useEffect(() => {
    if (selectedAgencyGroup) {
      userSetupUtils.getAgenciesByGroup(selectedAgencyGroup)?.then(res => {
        setAgencyList(res);
        // setEmployeeStatus(res)
      })
    }
  }, [selectedAgencyGroup]);

  const handleAgencyGroupChange = async (newValue) => {
    setSelectedAgencyGroup(newValue);
  };
  const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {
    setEmployeeDetail({
      ...employeeDetail,
      [propName]: value,
    });

    // if (propName == 'firstName' || propName == 'lastName') {
    //     setEmployeeDetail(cst => {
    //         return {
    //         ...cst,
    //         displayName: (cst.firstName ? cst.firstName : '') + ' ' + (cst.lastName ? cst.lastName : ''),
    //         };
    //       });
    // }
  }

  const SaveEmployee = async () => {
    try {
      let validationError = employeeSetupService.validateEmployee(employeeDetail);
      employeeDetail.workPhone = employeeDetail.workPhone?.replace(/-/g, "");
      setFormValidation(validationError);
      if (Object.keys(validationError).length > 0) {
        toast.warn(constant.CUSTOMER_FORM_VALIDATION_ERROR_MESSAGE, {
          position: toast.POSITION.TOP_RIGHT
        });
        return;
      }
      if (employeeDetail.id != constant.DEFAULT_GUID && employeeDetail.id != null) {
        let updatedEmployer = await employeeSetupService.saveEmployee(employeeDetail, true); //Fetching Display Name
        UpdateEmployeeOnUI();
        toast.success("Saved Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: constant.AUTO_CLOSE
        });
        setDataSaved(true);
      }
      else {
        let updatedEmployer = await employeeSetupService.saveEmployee(employeeDetail, false);
        if (updatedEmployer) {
          employeeDetail = updatedEmployer;

          UpdateEmployeeOnUI();
          toast.success("Saved Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: constant.AUTO_CLOSE
          });
          setDataSaved(true);
        }
        else {
          toast.error(constant.CUSTOMER_ERROR_WHILE_SAVING, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      }
    }
    catch (e) {
      if (e.status == 400 || e.data != null) {
        Logger.logError(e.data, e);
        toast.error(e.data, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      else {
        Logger.logError(constant.CUSTOMER_ERROR_WHILE_SAVING, e);
        toast.error(constant.CUSTOMER_ERROR_WHILE_SAVING, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }

  const UpdateEmployeeOnUI = async () => {
    var data = await userSetupUtils.getEmployeeDetails(employeeDetail.id);
    employeeDetail = data;
    setEmployeeDetail({
      ...employeeDetail
    });
  }

  const CancelEdit = () => {
    setOpen("0"); // Close accordion panel
    if (savedData) {
      loadDataFlag(true);
    }
    else {
      loadDataFlag(false);
    }
  };

  return (



    <Container fluid>
      <Row>
        <Column lg={6} md={6}>&nbsp;</Column>
        <Column lg={6} md={6}>&nbsp;</Column>
      </Row>


      <Row>
        <Column lg={3} md={3}>
          <FloatingLabel
            controlId="firstName"
            label={<>
              {cstScrLables.FIRST_NAME}
              <span className="text-danger">*</span>
            </>}>
            <Form.Control
              autoFocus
              type="text"
              name="firstName"
              placeholder={cstScrLables.FIRST_NAME}
              value={employeeDetail.firstName}
              onChange={(event) => onEntityFieldChange('firstName', event.currentTarget.value)}
              disabled={!isEditable}
              maxLength={60}
              required={true}
              isInvalid={formValidation['firstName']?.isValid == false}
              tabIndex={1}
              // ref={firstNameRef}
              ref={firstNameRef}
              onKeyDown={(e) => {
                  if (e.key == "Tab" && e.shiftKey) {
                      e.preventDefault();
                  }
              }}
            />
            <Form.Control.Feedback type="invalid">
              {formValidation['firstName']?.warningText}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Column>

        <Column lg={3} md={3}>
          <Select
            id="agencyGroupId"
            controlId="agencyGroupId"
            className="mb-3"
            label={cstScrLables.AGENCY_GROUP}
            options={agencyGroups}
            defaultSelected={agencyGroups?.filter(option =>
              option.value === employeeDetail.agencyGroupId
            )}
            onChange={(values) => {
              onEntityFieldChange('agencyGroupId', values[0] as string);
              handleAgencyGroupChange(values[0] as string);
            }}
            disabled={!isEditable}
            isRequired={true}
            isInvalid={formValidation['agencyId']?.isValid == false}
            invalidWarning={formValidation['agencyId']?.warningText}
            placeholder={cstScrLables.AGENCY_GROUP}
            multiple={false}
            tabIndex={5}
          />
        </Column>
        <Column lg={3} md={3}>
          <Select
            id="fullPartTimeIndId"
            controlId="fullPartTimeIndId"
            className="mb-3"
            label={cstScrLables.FULLTIME_INDICATOR}
            options={indicatorList}
            defaultSelected={indicatorList?.filter(option =>
              option.value === employeeDetail.fullPartTimeIndId
            )}
            onChange={(values) => onEntityFieldChange('fullPartTimeIndId', values[0] as string)}
            disabled={!isEditable}
            placeholder={cstScrLables.FULLTIME_INDICATOR}
            multiple={false}
            tabIndex={9}
          />
        </Column>
        <Column lg={3} md={3}>
          <FloatingLabel
            controlId="enteredDate"
            label={cstScrLables.ENTERED_DATE}
          >
            <Form.Control
              type="text"
              name="enteredDate"
              placeholder={cstScrLables.ENTERED_DATE}
              value={employeeDetail.enteredDate ?? ""}
              disabled={true}
              maxLength={60}
              readOnly
            />
          </FloatingLabel>
        </Column>
      </Row>
      <Row>
        <Column lg={3} md={3}>
          <FloatingLabel
            controlId="middleName"
            label={cstScrLables.MIDDLE_NAME}
          >
            <Form.Control
              type="text"
              name="middleName"
              placeholder={cstScrLables.MIDDLE_NAME}
              value={employeeDetail.middleName ?? ""}
              onChange={(event) => onEntityFieldChange('middleName', event.currentTarget.value)}
              disabled={!isEditable}
              maxLength={100}
              tabIndex={2}
            />
          </FloatingLabel>
        </Column>
        <Column lg={3} md={3}>

          <Select
            id="agencyId"
            controlId="agencyId"
            className="mb-3"
            label={cstScrLables.AGENCY}
            options={agencies}
            defaultSelected={agencies?.filter(option =>
              option.value === employeeDetail.agencyId
            )}
            onChange={(values) => onEntityFieldChange('agencyId', values[0] as string)}
            disabled={!isEditable}
            isRequired={true}
            isInvalid={formValidation['agencyId']?.isValid == false}
            invalidWarning={formValidation['agencyId']?.warningText}
            placeholder={cstScrLables.AGENCY}
            multiple={false}
            tabIndex={6}
          />
        </Column>

        <Column lg={3} md={3}>
          <Row>
            <Column lg={8} md={8}>
              <FloatLabel>
                <InputMask
                  name="WorkPhone"
                  value={employeeDetail.workPhone?.trim()}
                  onChange={(event) => onEntityFieldChange('workPhone', event.value)}
                  disabled={!isEditable}
                  mask="999-999-9999"
                  tabIndex={10}
                  placeholder={cstScrLables.PHONE} />
                <label>{cstScrLables.WORK_PHONE}</label>
              </FloatLabel>
            </Column>
            <Column lg={4} md={4}>
              <FloatLabel>
                <InputMask
                  name="workPhoneExt"
                  value={employeeDetail.workPhoneExt?.trim()}
                  onChange={(event) => onEntityFieldChange('workPhoneExt', event.value)}
                  disabled={!isEditable}
                  mask="99999"
                  tabIndex={11}
                  placeholder={cstScrLables.EXT} />
                <label>{cstScrLables.EXT}</label>
              </FloatLabel>
            </Column>
          </Row>

        </Column>
        <Column lg={3} md={3}>
          <FloatingLabel controlId="changedDate" label={cstScrLables.UPDATED_DATE}>
            <Form.Control
              type="text"
              name="changedDate"
              placeholder={cstScrLables.UPDATED_DATE}
              value={employeeDetail.changedDate ?? ""}
              disabled={true}
              maxLength={60}
              readOnly
            />
          </FloatingLabel>


        </Column>
      </Row>

      <Row>
        <Column lg={3} md={3}>
          <FloatingLabel controlId="lastName"
            label={<>
              {cstScrLables.LAST_NAME}
              <span className="text-danger">*</span>
            </>}          >
            <Form.Control
              type="text"
              name="lastName"
              placeholder={cstScrLables.LAST_NAME}
              value={employeeDetail.lastName ?? ""}
              onChange={(event) => onEntityFieldChange('lastName', event.currentTarget.value)}
              disabled={!isEditable}
              maxLength={60}
              required={true}
              tabIndex={3}
              isInvalid={formValidation['lastName']?.isValid == false}
            />
            <Form.Control.Feedback type="invalid">
              {formValidation['lastName']?.warningText}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Column>

        <Column lg={3} md={3}>
          <Select
            id="employeeSupervisor"
            controlId="employeeSupervisor"
            className="mb-3"
            label={cstScrLables.SUPERVISOR}
            options={employeeList}
            defaultSelected={employeeList?.filter(option =>
              option.value === employeeDetail.empSupervisorCode
            )}
            onChange={(values) => onEntityFieldChange('empSupervisorCode', values[0] as string)}
            disabled={!isEditable}
            placeholder={cstScrLables.SUPERVISOR}
            multiple={false}
            tabIndex={7}
          />
        </Column>

        <Column lg={3} md={3}>
          <FloatingLabel
            controlId="countryCode"
            label={cstScrLables.COUNTRY_CODE}
          >
            <Form.Control
              type="text"
              name="countryCode"
              placeholder={cstScrLables.COUNTRY_CODE}
              value={employeeDetail.countryCode ?? ""}
              onChange={(event) => onEntityFieldChange('countryCode', event.currentTarget.value)}
              disabled={!isEditable}
              maxLength={2}
              tabIndex={12}
            />
          </FloatingLabel>
        </Column>

        <Column lg={3} md={3}>
          <FloatingLabel controlId="changedByName" label={label.UPDATED_BY}>
            <Form.Control
              type="text"
              name="changedByName"
              placeholder={label.UPDATED_BY}
              value={employeeDetail.changedByName ?? ""}
              disabled={true}
              maxLength={60}
              readOnly
            />
          </FloatingLabel>
        </Column>
      </Row>

      <Row>
        <Column lg={3} md={3}>
          <FloatingLabel controlId="email" label={<>
            {cstScrLables.EMAIL}
            <span className="text-danger">*</span>
          </>}   >
            <Form.Control
              type="text"
              name="email"
              placeholder={cstScrLables.EMAIL}
              value={employeeDetail.email ?? ""}
              onChange={(event) => onEntityFieldChange('email', event.currentTarget.value)}
              disabled={!isEditable}
              maxLength={60}
              required={true}
              isInvalid={formValidation['email']?.isValid == false}
              tabIndex={4}
            />
            <Form.Control.Feedback type="invalid">
              {formValidation['email']?.warningText}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Column>
        <Column lg={3} md={3}>
          <FloatingLabel controlId="title" label={cstScrLables.TITLE}>
            <Form.Control
              type="text"
              name="title"
              placeholder={cstScrLables.TITLE}
              onChange={(event) => onEntityFieldChange('title', event.currentTarget.value)}
              value={employeeDetail.title ?? ""}
              disabled={!isEditable}
              maxLength={60}
              tabIndex={8}
            />
          </FloatingLabel>

        </Column>
        <Column lg={3} md={3}>
          <Checkbox
            id='isActive'
            label="Active"
            checked={employeeDetail.isActive}
            //className='checkbox-style'
            // checked={employeeDetail.status}
            onChange={(event) => manageActiveToggle(event)}
            tabIndex={13}
          />
        </Column>
        <Column lg={3} md={3}>
          <Select
            id="employeeDepartmentId"
            controlId="employeeDepartmentId"
            className="mb-3"
            label="Employee Department"
            options={employeeDepartmentOptions}
            defaultSelected={employeeDepartmentOptions?.filter(option =>
              option.value === employeeDetail.departmentId
            )}
            onChange={(values) => onEntityFieldChange('departmentId', values[0] as string)}
            disabled={!isEditable}
            placeholder="Employee Department"
            multiple={false}
            tabIndex={14}
          />
        </Column>
      </Row>

      <Row>
        <Column lg={12} md={12}>
          <div className="d-flex justify-content-between align-items-center mb-3 div-margin">
            <div>
              <Button
                              variant="outline-primary"
                onClick={() => CancelEdit()}
                tabIndex={20}
                id="btnCancel"
                disabled={false}
                              style={{ minWidth: "90px" }}
                              className="me-2"
              >
                {label.CLOSE.toLocaleUpperCase()}
              </Button>
            </div>
            <div>
              <Button
                variant="outline-danger"
                className='btn btn-outline-primary me-3'
                key="edit-btn"
                onClick={() => EditCustomer()}
                tabIndex={21}
                              id="btnEdit"
                              color='primary'
                disabled={!canDelete}
              >
                {'DELETE'}
              </Button>
              <Button
                className='btn btn-primary'
                key="save-btn"
                onClick={() => SaveEmployee()}
                tabIndex={21}
                id="btnAddCustomer"
                disabled={!canUpdate}
                              color='primary'
                              onKeyDown={(e) => {
                  if (e.key == "Tab" && !e.shiftKey) {
                    firstNameRef.current.focus();
                      e.preventDefault();
                  }
              }}
              >
                {label.SAVE.toLocaleUpperCase()}
              </Button>
            </div>
          </div>
        </Column>
      </Row>

    </Container>
  );
};
export default EmployeeDetails;